module.exports = __webpack_public_path__ + "static/media/12.6eaf46eb.jpg";